import Route from '@ember/routing/route';

export default class CoachingCoachSettingsRoute extends Route {}
